import React, { Component } from 'react'
import CommonHeader from '../../navbars/CommonHeader';

// Analysis page header: the shared CommonHeader, in a colour of its own
// (page styles from .strength-nav).
class StrengthNavbar extends Component {
    render() {
        return (
            <CommonHeader className="strength-nav" color="auto" tone="light" container={false} onToggleSidebar={this.props.onClick} title={"Strength Analysis"} />
        )
    }
}

export default StrengthNavbar;
